import React, { Component } from "react"

/* Link */
import { NavLink } from "react-router-dom"

/* Redux */
import { connect } from "react-redux"

/* Constants */
import { menu } from "../constants"



/* Component Mobile Tab */
class MobileTab extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
        }
    }


    componentDidMount = () => {
        document.addEventListener("click", this.handleClickOutside, true)
    }

    componentWillUnmount = () => {
        document.removeEventListener("click", this.handleClickOutside, true)
    }


    /* Click Outside Handler */
    handleClickOutside = (event) => {
        if (this._bar && !this._bar.contains(event.target)) {
            this.setState({ visible: false })
        }
    }


    render = () => {

        const { visible } = this.state

        const { admin } = this.props

        return (
            <div className="mobile-menu-container">

                <div className="mobile-menu">

                    {menu.getData().map((item, index) => {

                        if (item.name === "space" || index > 3) {
                            return <div key={`${index}`} />
                        }

                        return (
                            <NavLink onClick={() => this.setState({ visible: false })} key={`${index}`} to={item.link} className="mobile-menu-item">
                                <div className="mobile-menu-image">
                                    {item.image}
                                </div>
                            </NavLink>
                        )
                    })}

                    <div onClick={() => this.setState({ visible: !visible })} className={`mobile-menu-item ${visible ? "active" : ""}`}>
                        <div className="mobile-menu-image">
                            <img src="/images/dots.png" alt="More" />
                        </div>
                    </div>

                </div>

                <div ref={(ref) => this._bar = ref} className={`mobile-menu-bar ${visible ? "active" : ""}`}>
                    {menu.getData().map((item, index) => {

                        if (item.superadmin && !(admin && admin.isAdmin)) {
                            return null
                        }

                        if (item.extended && !(admin && (admin.isAdmin || admin.extendedAccess))) {
                            return null
                        }

                        if (item.name === "space" || index < 4) {
                            return <div key={`${index}`} />
                        }

                        return (
                            <NavLink onClick={() => this.setState({ visible: false })} key={`${index}`} to={item.link} className="mobile-menu-bar-item">
                                <div className="mobile-menu-bar-image">
                                    {item.image}
                                </div>
                                <span>{item.text}</span>
                            </NavLink>
                        )
                    })}
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        admin: state.admin,
    }
}

export default connect(mapStateToProps)(MobileTab)